import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';

/**
 * GLTFLoader с MeshoptDecoder для GLB, публикуемых SKP-воркером.
 *
 * С 10.10.2026 клиентский артефакт нативного КП сжимается gltfpack'ом
 * (EXT_meshopt_compression + floating-point квантование позиций/UV;
 * tools/skp_decoder_go/meshopt_compress.go): реальная кухня 31 МБ -> 6,4 МБ,
 * gzip 9,3 -> 3,0 МБ, поэтому и канал, и парсинг браузером быстрее.
 *
 * РЕГРЕССИЯ СТАРЫХ ЭКСПОРТОВ ИСКЛЮЧЕНА ПОСТРОЕНИЕМ: декодер включается
 * ВСЕГДА и безвреден для несжатых GLB — EXT_meshopt_compression активен
 * только когда артефакт его объявляет, старые замороженные ссылки (без
 * расширения) грузятся прежним путём.
 */
export function createMeshoptGltfLoader(): GLTFLoader {
  const loader = new GLTFLoader();
  loader.setMeshoptDecoder(MeshoptDecoder);
  return loader;
}
